import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class FinderThemeService {

    private currentTheme;
    private themeChanged = new BehaviorSubject<string>(null);

    constructor() { }

    /**
     * Sets the current theme
     * @param theme {string} theme to set
     */
    setCurrentTheme(theme: string) {
        this.currentTheme = `${theme}-theme`;
        this.themeChanged.next(this.currentTheme);
    }

    /**
     * Returns Observable with theme change events
     * @return Observable<string>
     */
    themeChange(): Observable<string> {
        return this.themeChanged.asObservable();
    }

    getCurrentTheme() {
        return this.currentTheme;
    }
}
